import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as rewardsApi from "../services/ApiServices/ApiService";
import { logTrace } from "../services/ApiServices/LoggingService";
import { UserContext } from "../context/userContext";
import PrimaryNavigation from "./PrimaryNavigation";

const Header = ({ embedded = false }) => {
  const [gatewayUrl, setGatewayUrl] = useState(null);

  const navigate = useNavigate();
  const user = useContext(UserContext);
  const onboarded =
    user?.enrollmentStatus?.participationIndicator &&
    user?.enrollmentStatus?.taxInfo &&
    user?.enrollmentStatus?.bankingOnFile;

  const getFederatedLoginUrl = () => {
    const handleError = (error) => {
      logTrace(
        error,
        "error when calling rewardsApi.getExternalUrls",
        "getFederatedLoginUrl in Header.jsx"
      );
    };
    const handleSuccess = (response) => {
      setGatewayUrl(response.gatewayUrl);
    };

    rewardsApi.getExternalUrls(handleSuccess, handleError);
  };

  useEffect(() => {
    getFederatedLoginUrl();
  }, []);

  const routeToEarnings = () => {
    navigate("/earnings", { state: { editMode: true } });
  };

  const routeToOnboarding = (event) => {
    event.preventDefault();
    navigate("/onboarding", { state: { editMode: true } });
  };

  return (
    <>
      <header id="primary-header" role="banner">
        {!embedded && (
          <div className="header-logo" data-testid="header-logo">
            <a className="icon-geico" aria-label="GEICO Home" href="/" data-trackid="geico-home"></a>
          </div>
        )}
        {embedded && <div className="header-logo header-logo--embedded-spacer" aria-hidden="true" />}

        <div className="header-links">
          <ul>
            {!embedded && (
              <li className="gateway-link" data-testid="gateway-link">
                {gatewayUrl && (
                  <a href={gatewayUrl} target="_blank" rel="noreferrer" data-trackid="gateway">
                    <span className="icon-profile"></span>
                    <span className="header-link">Gateway</span>
                  </a>
                )}
              </li>
            )}
            <li data-testid="earnings-link">
              <a
                href="/earnings"
                onClick={routeToEarnings}
                data-trackid="view-my-earnings"
                {...(embedded
                  ? {}
                  : { target: "_blank", rel: "noreferrer" })}
              >
                <span className="icon-cash"></span>
                <span className="header-link">View My Earnings</span>
              </a>
            </li>
            {embedded && onboarded &&
              <li data-testid="w9-bank-info-link">
                <a
                  href="/onboarding"
                  onClick={routeToOnboarding}
                  data-trackid="w9-and-bank-info"
                  {...(embedded
                    ? {}
                    : { target: "_blank", rel: "noreferrer" })}
                >
                  <span className="icon-edit"></span>
                  <span className="header-link">W-9 and Bank Info</span>
                </a>
              </li>
            }
            {!embedded && (
              <li className="menu" data-testid="menu">
              <a
                data-side-panel-trigger="menu"
                className="hamburger-menu"
                href="/"
                data-trackid="menu"
                data-track-type="button"
              >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span className="header-link">Menu</span>
              </a>
              </li>
            )}
          </ul>
        </div>
      </header>
      {!embedded && <PrimaryNavigation />}
    </>
  );
};

export default Header;
